import { render, staticRenderFns } from "./packageExpress.vue?vue&type=template&id=4a1b09a6"
import script from "./packageExpress.vue?vue&type=script&lang=js"
export * from "./packageExpress.vue?vue&type=script&lang=js"
import style0 from "./packageExpress.vue?vue&type=style&index=0&id=4a1b09a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports